export const HIDE_POPUP = "HIDE_POPUP";
export const SHOW_POPUP = "SHOW_POPUP";
export const UPDATE_POINTS = "UPDATE_POINTS";
export const UPDATE_COINS = "UPDATE_COINS";
export const TOGGLE_NAVBAR = "TOGGLE_NAVBAR";
export const TOGGLE_PRELOADER = "TOGGLE_PRELOADER";
export const GET_LESSON_DATA = "GET_LESSON_DATA";
export const GET_USER_ID = "GET_USER_ID";
